import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import { motion } from 'framer-motion';

import heroImg from '../../static/media/home/main.webp';



const darkGrey = '#e65100';

const hoverGrey = '#ff781f';

const secondaryYellow = '#ff9100ff';

const primaryOrange = '#e65100';



const MainHeaderSection = () => (

  <Box

    component="section"

    className="main-header-section"

    sx={{

      position: 'relative',

      py: { xs: 6, md: 10 },

      px: { xs: 2, md: 6 },

      '&.main-header-section': {

        maxWidth: '90%',

        margin: '0 auto',

      },

    }}

  >

    <Box

      sx={{

        display: 'flex',

        flexDirection: { xs: 'column', md: 'row' },

        alignItems: 'center',

        justifyContent: 'space-between',

        gap: { xs: 4, md: 6 },

      }}

    >

      <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' } }}>

        <motion.div

          initial={{ opacity: 0, y: -40 }}

          whileInView={{ opacity: 1, y: 0 }}

          transition={{ duration: 0.8 }}

          viewport={{ once: true, amount: 0.3 }}

        >

          <Typography

            component="h1"

            sx={{

              fontWeight: 'bold',

              fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.3rem' },

              lineHeight: 1.3,

              mb: 3,

              color: '#4a4a4a',

            }}

          >

            Venta de equipos,

            mantenimiento de laptops y

            recuperación de

            datos.

          </Typography>

        </motion.div>



        <motion.div

          initial={{ opacity: 0, scale: 0.8 }}

          whileInView={{ opacity: 1, scale: 1 }}

          transition={{ duration: 0.8, delay: 0.2 }}

          viewport={{ once: true, amount: 0.3 }}

        >

          <Typography

            component="h2"

            sx={{

              fontWeight: 'bold',

              fontSize: { xs: '1.2rem', md: '1.5rem' },

              mb: 2,

              background: `linear-gradient(to right, ${primaryOrange}, ${secondaryYellow})`,

              WebkitBackgroundClip: 'text',

              WebkitTextFillColor: 'transparent',

              display: 'inline-block',

            }}

          >

            CM SOLUTION AND TECHNOLOGY

          </Typography>

        </motion.div>



        <motion.div

          initial={{ opacity: 0, x: -40 }}

          whileInView={{ opacity: 1, x: 0 }}

          transition={{ duration: 0.8, delay: 0.3 }}

          viewport={{ once: true, amount: 0.3 }}

        >

          <Typography

            component="h3"

            sx={{

              fontWeight: 'bold',

              fontSize: '1rem',

              color: '#b84000ff',

              mb: 2,

            }}

          >

            EQUIPOS • MANTENIMIENTO • DATOS • TECNOLOGÍA

          </Typography>



          <Typography

            variant="body1"

            sx={{

              fontSize: '0.95rem',

              lineHeight: 1.7,

              color: '#444',

              mb: 4,

            }}

          >

            Contamos con soluciones integrales en hardware, servicio técnico especializado y

            recuperación avanzada de información. Tecnología al servicio de tu negocio, con

            atención personalizada, soporte posventa, diagnósticos precisos, experiencia

            profesional y compromiso total con cada cliente.

          </Typography>

        </motion.div>



        <motion.div

          initial={{ opacity: 0, y: 30 }}

          whileInView={{ opacity: 1, y: 0 }}

          transition={{ duration: 0.8, delay: 0.4 }}

          viewport={{ once: true, amount: 0.3 }}

        >

          <Box

            sx={{

              display: 'flex',

              gap: 2,

              flexWrap: 'wrap',

              justifyContent: { xs: 'center', md: 'flex-start' },

            }}

          >

            <Button

              component="a"

              href="/contacto"

              variant="contained"

              sx={{

                bgcolor: darkGrey,

                color: '#fff',

                fontWeight: 'bold',

                px: { xs: 2.5, sm: 4 },

                py: { xs: 0.7, sm: 0.9 },

                fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },

                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',

                '&:hover': { bgcolor: hoverGrey },

              }}

            >

              CONTÁCTANOS

            </Button>



            <Button

              component="a"

              href="/categorias"

              variant="outlined"

              sx={{

                borderColor: darkGrey,

                color: darkGrey,

                fontWeight: 'bold',

                px: { xs: 2.5, sm: 4 },

                py: { xs: 0.7, sm: 0.9 },

                fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },

                '&:hover': {

                  bgcolor: '#f5f5f5',

                  borderColor: hoverGrey,

                  color: hoverGrey,

                },

              }}

            >

              NUESTROS PRODUCTOS

            </Button>

          </Box>

        </motion.div>

      </Box>



      <Box

        sx={{

          flex: 1,

          display: 'flex',

          justifyContent: 'center',

          alignItems: 'center',

        }}

      >

        <motion.img

          src={heroImg}

          alt="Cursos y certificaciones profesionales"

          style={{

            borderRadius: '12px',

            maxWidth: '85%',

            boxShadow: '0 12px 24px rgba(0,0,0,0.25)',

          }}

          initial={{ opacity: 0, x: 60 }}

          whileInView={{ opacity: 1, x: 0 }}

          transition={{ duration: 0.8, delay: 0.2 }}

          viewport={{ once: true, amount: 0.3 }}

        />

      </Box>

    </Box>

  </Box>

);



export default MainHeaderSection;